<template>
  <div class="row table-responsive">
    <div class="col-lg-12">
      <table class="table">
        <th class="text-left">{{ $t("import_type") }}</th>
        <th class="text-left">{{ $t("import_source_type") }}</th>
        <th class="text-left">{{ $t("common.file") }}</th>
        <th class="text-left">{{ $t("common.file_size") }}</th>
        <th class="text-left">{{ $t("common.status") }}</th>
        <th class="text-center">{{ $t("common.upload_date") }}</th>
        <th class="text-center">{{ $t("common.processed_at") }}</th>
        <th></th>
        <th></th>
        <tbody>
          <tr v-for="item in items" :key="item.id" @mouseover="hoveredRow = item.id"
            @mouseleave="hoveredRow = null">
            <td class="td-text text-left" :data-title="$t('import_type')"
              :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.import_type }}
            </td>
            <td class="td-text text-left" :data-title="$t('import_source_type')"
              :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.import_source_type }}
            </td>
            <td class="td-text text-left" :data-title="$t('common.file')" :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.filename }}
            </td>
            <td class="td-text text-left" :data-title="$t('common.file_size')"
              :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.file_size_mb }}
            </td>
            <td class="td-text text-left" :class="[getInfo(item).color, isHovered(item.id) ? 'selection-row' : '']"
              :data-title="$t('common.status')">
              {{ liveStatusText(item) || formatStatus(item.status) }}
            </td>
            <td class="td-text text-center" :data-title="$t('common.upload_date')"
              :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.created_at }}
            </td>
            <td class="td-text text-center" :data-title="$t('common.processed_at')"
              :class="{ 'selection-row': isHovered(item.id) }">
              {{ item.processed_at }}
            </td>
            <td class="td-text text-center" :class="{ 'selection-row': isHovered(item.id) }">
              <img :src="require('@/assets/images/desktop/icons/controls/edit.svg')"
                :title="$t('tools.import.import_data_validation')" class="status-icon"
                @click="goToImportValidatorPage(item.import_type, item)" v-if="getDataValidationIsAvailable(item)" />
              <img :src="require('@/assets/images/desktop/icons/controls/delete.svg')"
                :title="$t('tools.import.delete_from_live_data')" class="status-icon" @click="showConfirmDelete(item)"
                v-if="getDataValidationIsTransferedToLiveData(item)" />
            </td>
            <td class="td-text text-center" :class="{ 'selection-row': isHovered(item.id) }">
              <img :src="getInfo(item).path" :class="[getInfo(item).icon, getInfo(item).iconColor]"
                :title="getInfo(item).status" class="status-icon" @click="infoActionEvemt(item)" />
              <img src="~@/assets/images/icons/refresh_map.svg" class="refresh-icon primary-filter c-pointer p-2" v-if="
                getImportError(item) &&
                getImportError(item).message_type === 'structure_errors' &&
                getInfo(item).retry
              " @click="retry(item)" />
            </td>
          </tr>
        </tbody>
      </table>
      <import-summary-dialog :show="showImportSummaryModal" @close="showImportSummaryModal = false"
        :data="importSummaryModalData" @onOK="showImportSummaryModal = false"></import-summary-dialog>
      <delete-confirmation-dialog :show="showDeleteConfirmationModal" @close="closeConfirmDelete"
        @confirm="deleteLiveDataByImport" :item="itemToDelete" :title="$t('tools.import.delete_from_live_data')"
        :message="revocationMessage"></delete-confirmation-dialog>
    </div>
  </div>
</template>

<script>
import ImportSummaryDialog from "./ImportSummaryDialog";
import DeleteConfirmationDialog from "@/components/Modals/DeleteConfirmationDialog";
import { infoMessage, successMessage, errorMessageList, errorMessage } from "~/helpers/common";
import { types } from "@/helpers/ImportTypes";
import { mapActions } from "vuex";
import axios from 'axios';

export default {
  name: "FileList",
  props: ["data"],
  data() {
    return {
      items: this.data ? this.data : [],
      importSummaryModalData: {},
      showImportSummaryModal: false,
      showDeleteConfirmationModal: false,
      importTypes: types,
      hoveredRow: null,
      itemToDelete: null,
      itemToLiveData: null,
      specialCaseWorkCount: 0,
      liveOperations: {},
      liveStatusLoaded: {},
      liveStatusTimer: null,
      liveStatusFetching: false,
      liveStatusRevision: 0,
      liveStatusDestroyed: false,
    };
  },
  components: {
    ImportSummaryDialog,
    DeleteConfirmationDialog,
  },
  computed: {
    liveOperationInProgress() {
      return Object.values(this.liveOperations).some((operation) => ["submitting", "queued", "running"].includes(operation.status));
    },
    revocationMessage() {
      const message = this.$t('tools.import.delete_from_live_data_question');
      return this.specialCaseWorkCount > 0 ? message + ' ' + this.$t('tools.special_cases.revoke_warning', { count: this.specialCaseWorkCount }) : message;
    },
  },
  methods: {
    ...mapActions({
      deleteValidatedDataFromLiveData: 'importConfig/deleteValidatedDataFromLiveData',
      transferValidatedDataToLiveData: 'importConfig/transferValidatedDataToLiveData',
    }),
    isLiveOperationBusy(item) {
      return ["submitting", "queued", "running"].includes(this.liveOperations[item.import_id]?.status);
    },
    liveStatusText(item) {
      const operation = this.liveOperations[item.import_id];
      if (!operation) return "";
      if (this.isLiveOperationBusy(item)) return this.$t(`tools.import.live_operation_${operation.status === "submitting" ? "queued" : operation.status}`);
      return operation.status === "failed" ? this.$t("tools.import.live_operation_failed") : "";
    },
    applyLiveOperation(operation, notify = true) {
      const previous = this.liveOperations[operation.import_id];
      const wasBusy = previous && ["submitting", "queued", "running"].includes(previous.status);
      this.$set(this.liveOperations, operation.import_id, operation);
      this.$set(this.liveStatusLoaded, operation.import_id, true);
      if (operation.status === "succeeded") {
        this.updateProcessedAfterValidation(operation.import_id, operation.processed_after_validation);
      }
      if (notify && wasBusy && ["succeeded", "failed"].includes(operation.status)) {
        if (operation.status === "failed") {
          errorMessage(this, operation.error || this.$t("tools.import.live_operation_failed"));
        } else {
          successMessage(this, this.$t("tools.import.live_operation_completed"));
          this.$emit("live-operation-finished");
        }
      }
    },
    async pollLiveOperations() {
      if (this.liveStatusFetching || this.liveStatusDestroyed) return;
      const ids = [...new Set([
        ...Object.values(this.liveOperations).filter((operation) => ["submitting", "queued", "running"].includes(operation.status)).map((operation) => operation.import_id),
        ...this.items.filter((item) => item.import_type === this.importTypes.SGPS_DASC_IMPORT.id).map((item) => item.import_id),
      ].filter(Boolean))];
      if (!ids.length) return;
      const revision = this.liveStatusRevision;
      this.liveStatusFetching = true;
      try {
        for (let offset = 0; offset < ids.length; offset += 300) {
          const batch = ids.slice(offset, offset + 300);
          const response = await axios.get('/import-config/validated-data/live-operations', { params: { import_ids: batch } });
          if (this.liveStatusDestroyed || revision !== this.liveStatusRevision) return;
          const operations = response.data.data || [];
          operations.forEach((operation) => {
            if (this.liveOperations[operation.import_id]?.status !== "submitting") this.applyLiveOperation(operation);
          });
          batch.forEach((id) => {
            const local = this.liveOperations[id];
            if (local?.status === "queued" && !local.operation_uuid && !operations.some((operation) => operation.import_id === Number(id))) {
              this.applyLiveOperation({ ...local, status: "failed", error: this.$t("tools.import.live_operation_failed") });
            }
          });
          batch.forEach((id) => this.$set(this.liveStatusLoaded, id, true));
        }
      } catch (error) {
        return;
      } finally {
        this.liveStatusFetching = false;
      }
    },
    async startLiveOperation(action, data) {
      const importId = data.import_id || data.data_import_id;
      if (this.isLiveOperationBusy({ import_id: importId })) return;
      this.liveStatusRevision += 1;
      this.$set(this.liveOperations, importId, { import_id: importId, action, status: "submitting" });
      try {
        const response = action === "transfer" ? await this.transferValidatedDataToLiveData(data) : await this.deleteValidatedDataFromLiveData(data);
        if (this.liveStatusDestroyed) return;
        this.applyLiveOperation(response.data);
        this.pollLiveOperations();
      } catch (error) {
        if (this.liveStatusDestroyed) return;
        if (error.response?.status && error.response.status < 500) {
          this.$delete(this.liveOperations, importId);
          errorMessageList(this, error.response?.data?.errors || error.errors);
        } else {
          this.$set(this.liveOperations, importId, { import_id: importId, action, status: "queued" });
          this.pollLiveOperations();
        }
      } finally {
        this.itemToLiveData = null;
        this.itemToDelete = null;
      }
    },
    isHovered(id) {
      return this.hoveredRow === id;
    },
    async showConfirmDelete(item) {
      if (this.getDataValidationIsTransferedToLiveData(item)) {
        const response = await axios.get('/import-config/validated-data/revocation-preview', { params: { data_import_id: item.import_id } });
        this.specialCaseWorkCount = response.data.data.special_case_work_count;
        this.itemToDelete = item;
        this.showDeleteConfirmationModal = true;
      }
    },
    closeConfirmDelete() {
      this.itemToDelete = null;
      this.showDeleteConfirmationModal = false;
    },
    deleteLiveDataByImport() {
      this.showDeleteConfirmationModal = false;
      if (!this.itemToDelete) return;
      return this.startLiveOperation("revoke", {
        data_import_id: this.itemToDelete.import_id,
        department_uuid: this.itemToDelete.department_uuid,
        season_uuid: this.itemToDelete.season_uuid,
        confirm_special_cases: this.specialCaseWorkCount > 0 ? 1 : 0
      });
    },
    updateProcessedAfterValidation(import_id, processed_after_validation) {
      const item = this.items.find(
        (importRow) => String(importRow.import_id) === String(import_id)
      );
      if (item) {
        item.processed_after_validation = processed_after_validation;
      }
    },
    getImportError(item) {
      let error = item.processing_error || item.error;
      if (!error) {
        return null;
      }

      if (Array.isArray(error) && error.length === 1 && typeof error[0] === "string") {
        error = error[0];
      }

      for (let attempt = 0; attempt < 2 && typeof error === "string"; attempt++) {
        try {
          error = JSON.parse(error);
        } catch (e) {
          break;
        }
      }

      if (typeof error === "string") {
        error = { message: error };
      }

      if (error && typeof error === "object" && typeof error.message === "string") {
        const nestedMessage = error.message.trim();
        try {
          const nestedPayload = JSON.parse(nestedMessage);
          if (nestedPayload && typeof nestedPayload === "object") {
            error = nestedPayload;
          }
        } catch (e) {
          const messageType = nestedMessage.match(/\[message_type\]\s*=>\s*([^\r\n]+)/)?.[1]?.trim();
          if (messageType) {
            const title = nestedMessage.match(/\[title\]\s*=>\s*([^\r\n]+)/)?.[1]?.trim();
            const templateName = nestedMessage.match(/\[template\]\s*=>\s*Array[\s\S]*?\[name\]\s*=>\s*([^\r\n]+)/)?.[1]?.trim();
            const columnBlock = nestedMessage.match(/\[columns\]\s*=>\s*Array\s*\(([\s\S]*?)\s*\)/)?.[1];
            const columns = columnBlock
              ? columnBlock
                  .split(/\r?\n/)
                  .map((line) => line.match(/^\s*\[\d+\]\s*=>\s*([^\r\n]+)\s*$/)?.[1]?.trim())
                  .filter(Boolean)
              : [];
            const total = messageType === "structure_errors" ? columns.length : Number(nestedMessage.match(/\[total\]\s*=>\s*(\d+)/)?.[1]) || 0;
            const ignoredKeys = new Set(["message_type", "template", "optimized", "total", "date", "title", "message"]);
            const details = columns.length
              ? columns
              : nestedMessage
                  .split(/\r?\n/)
                  .map((line) => line.match(/^\s*\[([^\]]+)\]\s*=>\s*([^\r\n]+)\s*$/))
                  .filter((match) => match && !ignoredKeys.has(match[1]) && !["Array", "Object"].includes(match[2].trim()))
                  .map((match) => match[2].trim());
            error = {
              message_type: messageType,
              template: templateName || null,
              total,
              message: title ||
                (messageType === "validation_errors"
                  ? this.$t("tools.import_console.errors.validation_failed", { count: total })
                  : this.$t("tools.import_console.errors.structure_failed", { count: total })),
              errors: {
                error: messageType === "structure_errors" ? [{ template: { name: templateName }, columns: details }] : undefined,
                details: [...new Set(details)].slice(0, 20),
              },
            };
          } else {
            error.message = nestedMessage;
          }
        }
      }

      return error && typeof error === "object" ? error : { message: String(error) };
    },
    getInfo(item) {
      if (this.isLiveOperationBusy(item)) {
        return { color: "text-warning", iconColor: "primary-filter", icon: "queue",
          path: require("@/assets/images/desktop/icons/controls/queue.svg"), status: this.liveStatusText(item) };
      }
      const importError = this.getImportError(item);
      let data = {
        color: "text-secondary",
        iconColor: "secondary-filter",
        icon: "uploaded",
        path: require("@/assets/images/desktop/icons/controls/uploaded.svg"),
        status: this.formatStatus(item.status),
      };

      if (item.imported === 1) {
        //imported to company
        data = {
          color: "text-primary",
          iconColor: "primary-filter",
          icon: "queue",
          path: require("@/assets/images/desktop/icons/controls/queue.svg"),
          status: this.formatStatus(item.status),
        };
      }

      if (item.processed === 1) {
        data = {
          color: "text-success",
          iconColor: "success-filter",
          icon: "check-circle",
          path: require("@/assets/images/desktop/icons/controls/check-circle.svg"),
          type: "success",
          status: this.formatStatus(item.status),
        };
      }

      if (item.processed !== 1 && importError) {
        data = {
          color: "text-danger",
          iconColor: "danger-filter",
          icon: "check-circle",
          path: require("@/assets/images/desktop/icons/controls/alert.svg"),
          type: "error",
          retry: item.import_id,
          message_type: importError.message_type,
          status: this.formatStatus(item.status),
        };
      }

      if (this.getDataValidationIsAvailable(item)) {
        data = {
          color: "text-warning",
          iconColor: "primary-filter",
          icon: "transfer",
          path: require("@/assets/images/icons/transfer.svg"),
          status: this.$t('tools.import.transfer_to_live_data'),
        };
      }

      return data;
    },
    infoActionEvemt(item) {
      if (this.isLiveOperationBusy(item)) return;
      if (this.getDataValidationIsAvailable(item)) {
        item.uploaded_file_id = item.id;
        this.itemToLiveData = item;
        this.$emit("importValidatedDataEvent", item);
      } else {
        this.showDialog(item);
      }
    },
    showDialog(item) {
      let info = this.getInfo(item);

      if (info.type) {
        this.importSummaryModalData.title =
          info.type === "error"
            ? this.$t("tools.import_console.errors.import_error")
            : this.$t("tools.import_console.processed");
        this.importSummaryModalData.type = info.type;
        this.importSummaryModalData.info = info;
        this.importSummaryModalData.import_id = item.import_id;
        this.importSummaryModalData.import_type = item.import_type;
        this.importSummaryModalData.items =
          info.type === "error" ? this.getImportError(item) : item.success;
        this.showImportSummaryModal = true;
      }
    },
    retry(item) {
      if (this.isLiveOperationBusy(item)) return;
      let vm = this;

      if (item.import_id) {
        vm.$store
          .dispatch("common/retryCSVImport", {
            import_id: item.import_id,
          })
          .then(() => {
            infoMessage(
              vm,
              vm.$t("tools.configurator.added_to_queue", {
                file: item.filename,
              })
            );
            item.import_id = null;
          });
      }
    },
    goToImportValidatorPage(import_type, item) {
      if (this.getDataValidationIsAvailable(item)) {
        this.$router.push({
          path: "/tools/import-validator",
          query: { import_type: import_type, import_id: item.import_id },
        })
      }
    },
    /**
     * Checks if data validation is available for the given item.
     * @param {Object} item - The item to check.
     * @returns {boolean} - Returns true if data validation is available, false otherwise.
     */
    getDataValidationIsAvailable(item) {
      if (!this.liveStatusLoaded[item.import_id] || this.isLiveOperationBusy(item)) return false;
      if ((this.itemToDelete?.import_id ?? 0) != item.import_id && item.import_type === this.importTypes.SGPS_DASC_IMPORT.id &&
        (this.itemToLiveData?.import_id ?? 0) != item.import_id &&
        item.processed === 1 && item.processed_after_validation === 0) {
        return true;
      }
      return false;
    },
    /**
     * Determines if the data validation is transferred to live data.
     * 
     * @param {Object} item - The item to check.
     * @returns {boolean} - True if the data validation is transferred to live data, false otherwise.
     */
    getDataValidationIsTransferedToLiveData(item) {
      if (!this.liveStatusLoaded[item.import_id] || this.isLiveOperationBusy(item)) return false;
      if ((this.itemToDelete?.import_id ?? 0) != item.import_id && item.import_type === this.importTypes.SGPS_DASC_IMPORT.id &&
        (this.itemToLiveData?.import_id ?? 0) != item.import_id &&
        item.processed === 1 && item.processed_after_validation === 1) {
        return true;
      }
      return false;
    },
    formatStatus(status) {
      if (Array.isArray(status)) {
        return status.filter(Boolean).join(", ");
      }
      return status ?? "";
    },
    setItemToLiveData(item) {
      this.itemToLiveData = item;
    },
  },
  mounted() {
    this.pollLiveOperations();
    this.liveStatusTimer = setInterval(() => this.pollLiveOperations(), 3000);
  },
  beforeDestroy() {
    this.liveStatusDestroyed = true;
    clearInterval(this.liveStatusTimer);
  },
  watch: {
    liveOperationInProgress(value) {
      this.$emit("live-operation-progress", value);
    },
    data: {
      handler: function (newVal) {
        this.items = newVal;
        Object.values(this.liveOperations).filter((operation) => operation.status === "succeeded")
          .forEach((operation) => this.updateProcessedAfterValidation(operation.import_id, operation.processed_after_validation));
        this.pollLiveOperations();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.status-icon {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.selection-row {
  background-color: #e6e6e3;
}
</style>
